import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const DrinkingSmokingInfo = () => {
  const [drinkingSmokingInfo, setDrinkingSmokingInfo] = useState({
    drink: 50, // Default to "Sometimes"
    partnerDrink: '',
    smoke: 50, // Default to "Sometimes"
    partnerSmoke: '',
    smokeCannabis: 50, // Default to "Sometimes"
    partnerSmokeCannabis: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/drinking-smoking-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No drinking/smoking info found. Please set your info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch drinking/smoking info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const drinkingSmokingData = data.reduce((acc, item) => {
            if (item.question_text === 'Do you drink?')
              acc.drink = item.answer_int;
            if (item.question_text === 'Do you want a partner that drinks?')
              acc.partnerDrink = item.answer_text;
            if (item.question_text === 'Do you smoke?')
              acc.smoke = item.answer_int;
            if (item.question_text === 'Do you want a partner that smokes?')
              acc.partnerSmoke = item.answer_text;
            if (item.question_text === 'Do you smoke cannabis?')
              acc.smokeCannabis = item.answer_int;
            if (
              item.question_text ===
              'Do you want a partner that smokes cannabis?'
            )
              acc.partnerSmokeCannabis = item.answer_text;
            return acc;
          }, {});
          setDrinkingSmokingInfo(drinkingSmokingData);
        }
      })
      .catch((error) => {
        console.error('Error fetching drinking/smoking info:', error);
        setMessage('Error fetching drinking/smoking info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = {
      ...drinkingSmokingInfo,
      drink: parseInt(drinkingSmokingInfo.drink, 10),
      smoke: parseInt(drinkingSmokingInfo.smoke, 10),
      smokeCannabis: parseInt(drinkingSmokingInfo.smokeCannabis, 10),
    };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(
        `${API_BASE_URL}/api/drinking-smoking-info`,
        {
          method: method,
          headers: {
            'X-Stack-Access-Token': token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        throw new Error('Failed to update drinking/smoking info');
      }

      setMessage('Drinking/Smoking info updated successfully.');

      setTimeout(() => {
        navigate('/pets-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting drinking/smoking info:', error);
      setMessage('Failed to update drinking/smoking info.');
    }
  };

  const handleChange = (e) => {
    setDrinkingSmokingInfo({
      ...drinkingSmokingInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Drinking and Smoking Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">Do you drink?</label>
              <input
                type="range"
                name="drink"
                min="0"
                max="100"
                step="50"
                value={drinkingSmokingInfo.drink}
                onChange={handleChange}
                className="w-full slider"
              />
              <div className="flex justify-between">
                <span>No</span>
                <span>Sometimes</span>
                <span>Yes</span>
              </div>
            </div>

            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you want a partner that drinks?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="partnerDrink"
                    value="Yes"
                    checked={drinkingSmokingInfo.partnerDrink === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="partnerDrink"
                    value="No"
                    checked={drinkingSmokingInfo.partnerDrink === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>

            <div className="text-white">
              <label className="block text-sm font-medium">Do you smoke?</label>
              <input
                type="range"
                name="smoke"
                min="0"
                max="100"
                step="50"
                value={drinkingSmokingInfo.smoke}
                onChange={handleChange}
                className="w-full slider"
              />
              <div className="flex justify-between">
                <span>No</span>
                <span>Sometimes</span>
                <span>Yes</span>
              </div>
            </div>

            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you want a partner that smokes?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="partnerSmoke"
                    value="Yes"
                    checked={drinkingSmokingInfo.partnerSmoke === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="partnerSmoke"
                    value="No"
                    checked={drinkingSmokingInfo.partnerSmoke === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>

            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you smoke cannabis?
              </label>
              <input
                type="range"
                name="smokeCannabis"
                min="0"
                max="100"
                step="50"
                value={drinkingSmokingInfo.smokeCannabis}
                onChange={handleChange}
                className="w-full slider"
              />
              <div className="flex justify-between">
                <span>No</span>
                <span>Sometimes</span>
                <span>Yes</span>
              </div>
            </div>

            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you want a partner that smokes cannabis?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="partnerSmokeCannabis"
                    value="Yes"
                    checked={drinkingSmokingInfo.partnerSmokeCannabis === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="partnerSmokeCannabis"
                    value="No"
                    checked={drinkingSmokingInfo.partnerSmokeCannabis === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>

            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/ethnicity-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DrinkingSmokingInfo;
